import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const MembersPage = lazy(() => import('~/features/organization/pages/members-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/users')({
  beforeLoad: requirePermission('organization_members'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MembersPage />
    </Suspense>
  ),
});
